import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Share2 } from "lucide-react";
import { api, resolveFileUrl } from "../api";
import ShareSheet from "../components/ShareSheet";
import { StreamLinks } from "../components/StreamLinks";

export default function VideoDetailPage() {
  const { id } = useParams();
  const [v, setV] = useState(null);
  const [shareOpen, setShareOpen] = useState(false);
  useEffect(() => { api.get(`/content/videos/${id}`).then((r) => setV(r.data)); }, [id]);
  if (!v) return <div className="max-w-[1600px] mx-auto p-10 font-mono-label">Loading…</div>;
  const isEmbed = !!v.external_url;
  const isUpload = v.file_url && !isEmbed;
  return (
    <div className="pb-32 max-w-[1400px] mx-auto px-4 sm:px-6 py-10">
      <div className="font-mono-label text-[11px] text-[var(--accent)] mb-3">
        VIDEO / {v.genre} / {v.year}
      </div>
      <h1 className="font-display text-4xl md:text-6xl uppercase leading-none mb-4" data-testid="video-title">{v.title}</h1>
      <div className="flex items-center justify-between gap-4 flex-wrap mb-6">
        <div className="font-headline text-xl uppercase text-neutral-300" data-testid="video-artist">{v.artist}</div>
        <button onClick={() => setShareOpen(true)} className="btn-ghost" data-testid="video-share-btn">
          <Share2 size={14} /> Share
        </button>
      </div>
      <div className="border border-neutral-800 aspect-video bg-black mb-6">
        {isEmbed && (
          <iframe
            src={v.external_url}
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            data-testid="video-embed"
          />
        )}
        {isUpload && (
          <video src={resolveFileUrl(v.file_url)} controls className="w-full h-full" data-testid="video-player" />
        )}
        {!isEmbed && !isUpload && (
          <div className="flex items-center justify-center h-full font-mono-label text-neutral-500">No video source</div>
        )}
      </div>
      {v.description && <p className="text-neutral-400 max-w-3xl">{v.description}</p>}
      <StreamLinks links={v.stream_links} />
      <ShareSheet open={shareOpen} onClose={() => setShareOpen(false)} title={v.title} artist={v.artist} ctype="videos" id={v.id} />
    </div>
  );
}
